import { useEffect } from 'react';

const useModalBodyScroll = (isOpen, onOpen) => {
    useEffect(() => {
        if (isOpen) {
            onOpen && onOpen();
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }

        return () => {
            document.body.style.overflow = "auto";
        };
    }, [isOpen, onOpen]);
};

export default useModalBodyScroll;